import React, { ReactNode, useRef, useState } from 'react'
import styles from '../styles/tooltip.module.scss'
import Tooltip from 'react-bootstrap/Tooltip'
import Overlay from 'react-bootstrap/Overlay'
import { TooltipProps } from 'react-bootstrap'
import { ReactComponent as IconClose } from 'images/icons/icn_tooltip_close.svg'

interface Props extends TooltipProps {
  children: ReactNode
}

const withTooltip =
  Component =>
  ({ placement = 'auto', ...props }: Props) => {
    const [show, setShow] = useState(false)
    const target = useRef<HTMLSpanElement>(null)

    return (
      <>
        <span
          role={'button'}
          ref={target}
          className={styles.trigger}
          onClick={() => setShow(!show)}
        >
          <Component />
        </span>
        {/*@ts-ignore */}
        <Overlay target={target.current} show={show} placement={placement}>
          <Tooltip className={styles.tooltip} {...props}>
            <div className={styles.content}>{props.children}</div>
            <button className={styles.buttonClose} onClick={() => setShow(!show)}>
              <IconClose className={styles.icon} />
            </button>
          </Tooltip>
        </Overlay>
      </>
    )
  }

export default withTooltip
